<script setup>
  defineProps({
    text: String
  })
</script>

<template>
  <div
    class="left-headline lg:col-span-4"
    v-html="text"
  >
  </div>
</template>

<style lang="scss" scoped>
  :deep(p) {
    @apply uppercase mb-2 font-medium text-small-text ~text-xs/sm;
  }
  :deep(h1), :deep(h2), :deep(h3) {
    @apply ~text-xl/4xl font-normal mb-4;
    line-height: 1.4 !important;
  }
</style>
